import {ParentalLeaveSupportAllowanceFlow} from '../flow'

export const Confirm = () => <ParentalLeaveSupportAllowanceFlow />
